
import React, { lazy, Suspense, useState } from "react";
import {faFont} from "@fortawesome/sharp-solid-svg-icons"
import {faMarkdown} from "@fortawesome/free-brands-svg-icons"

const InputMarkdown = lazy(() => import("../inputs/input-markdown").then(module => ({ default: module.InputMarkdown })));
import { InputText } from "../inputs/input-text";
import { FormInput } from "./form-input";

function FormText(props) {
    const [markdownMode, setMarkdownMode] = useState("markdown");
    
    const changeHandler = (value) => {
        if (typeof props.OnChange === "function") {
            props.OnChange(value, props.Data);
        }
    };

    const blurHandler = (value) => {
        if (typeof props.OnBlur === "function") {
            props.OnBlur(value, props.Data);
        }
    };

    const copyToClipboardFallback = () => {
        try {
            const textarea = document.createElement("textarea");
            textarea.value = props.Value;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            return true;
        } catch (error) {
            return false;
        }
    };

    const copyToClipboard = async () => {
        if (navigator.clipboard) {
            try {
                await navigator.clipboard.writeText(props.Value);
            } catch (error) {
                copyToClipboardFallback()
            }
        } else {
            copyToClipboardFallback()
        }
    };

    const getMarkdownButtons = () => {
        let buttons = props.Buttons ? props.Buttons.slice() : [];
        if (markdownMode === "markdown") {
            buttons.push({
                Icon: faFont,
                Label: "Show text",
                Tooltip: "Switch to text mode",
                OnClick: () => setMarkdownMode("text")
            });
        } else {
            buttons.push({
                Icon: faMarkdown,
                Label: "Show markdown",
                Tooltip: "Switch to markdown mode",
                OnClick: () => setMarkdownMode("markdown")
            })
        }
        return buttons;
    };
    
    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }
    
    if (props.Markdown) {
        if (markdownMode === "markdown") {
            return (
                <FormInput Id={props.Id}
                           CollapsibleButtons={props.CollapsibleButtons}
                           Label={props.Label}
                           ShowRequiredIndicator={props.ShowRequiredIndicator}
                           RequiredStringIndicator={props.RequiredStringIndicator}
                           Class={props.Class}
                           Style={props.Style}
                           Grow={props.Grow}
                           Info={props.Info}
                           Width={props.Width}
                           ShowCopyButton={props.ShowCopyButton}
                           Copy={copyToClipboard}
                           Buttons={getMarkdownButtons()}
                           DataTestId={props.DataTestId}
                           AiPromptButtons={props.AiPromptButtons}
                           Tooltip={props.Tooltip}
                           TooltipTitle={props.TooltipTitle}
                           TooltipWidth={props.TooltipWidth}>

                    <Suspense fallback={<div className="eone-ui-markdown-loading">Loading editor...</div>}>
                        <InputMarkdown
                            Id={props.Id}
                            Ref={props.Ref}
                            AutoFocus={props.AutoFocus}
                            ReadOnly={props.ReadOnly}
                            MaxLength={props.MaxLength}
                            Style={props.InputStyle}
                            Code={props.Code}
                            Height={props.Height}
                            Width={props.Width}
                            Grow={props.Grow}
                            Value={props.Value}
                            Title={props.Title}
                            Placeholder={props.Placeholder}
                            SpellCheck={props.SpellCheck}
                            ShowToolbar={props.ShowMarkdownToolbar}
                            OnChange={changeHandler}
                            OnBlur={blurHandler}
                            DataTestId={props.DataTestId}/>
                    </Suspense>

                </FormInput>
            );
        }
        return (
            <FormInput Id={props.Id}
                       CollapsibleButtons={props.CollapsibleButtons}
                       Label={props.Label}
                       ShowRequiredIndicator={props.ShowRequiredIndicator}
                       RequiredStringIndicator={props.RequiredStringIndicator}
                       Class={props.Class}
                       Style={props.Style}
                       Grow={props.Grow}
                       Info={props.Info}
                       Width={props.Width}
                       ShowCopyButton={props.ShowCopyButton}
                       Copy={copyToClipboard}
                       Buttons={getMarkdownButtons()}
                       DataTestId={props.DataTestId}
                       AiPromptButtons={props.AiPromptButtons}
                       Tooltip={props.Tooltip}
                       TooltipTitle={props.TooltipTitle}
                       TooltipWidth={props.TooltipWidth}>

                <InputText
                    Id={props.Id}
                    AutoFocus={props.AutoFocus}
                    ReadOnly={props.ReadOnly}
                    MaxLength={props.MaxLength}
                    Style={props.InputStyle}
                    Code={props.Code}
                    Height={props.Height}
                    Width={props.Width}
                    Grow={props.Grow}
                    Value={props.Value}
                    Title={props.Title}
                    Placeholder={props.Placeholder}
                    SpellCheck={props.SpellCheck}
                    OnChange={changeHandler}
                    OnBlur={blurHandler}
                    DataTestId={props.DataTestId} />

            </FormInput>
        );
    }
    
    return (
        <FormInput Id={props.Id}
            CollapsibleButtons={props.CollapsibleButtons}
            Label={props.Label}
            ShowRequiredIndicator={props.ShowRequiredIndicator}
            RequiredStringIndicator={props.RequiredStringIndicator}
            Class={props.Class}
            Style={props.Style}
            Grow={props.Grow}
            Info={props.Info}
            Width={props.Width}
            ShowCopyButton={props.ShowCopyButton}
            Copy={copyToClipboard}
            Buttons={props.Buttons}
            DataTestId={props.DataTestId}
            AiPromptButtons={props.AiPromptButtons}
            Tooltip={props.Tooltip}
            TooltipTitle={props.TooltipTitle}
            TooltipWidth={props.TooltipWidth} >
            <InputText
                Id={props.Id}
                AutoFocus={props.AutoFocus}
                ReadOnly={props.ReadOnly}
                MaxLength={props.MaxLength}
                Style={props.InputStyle}
                Code={props.Code}
                Height={props.Height}
                Grow={props.Grow}
                Value={props.Value}
                Title={props.Title}
                Placeholder={props.Placeholder}
                SpellCheck={props.SpellCheck}
                OnChange={changeHandler}
                OnBlur={blurHandler}
                DataTestId={props.DataTestId} />
        </FormInput>
    );
}

export { FormText };